import { TransactionList } from './transactions'

export function createEmptyTransactionList(): TransactionList {
  return {
    page: 1,
    pages: 1,
    items: [],
  }
}
